import React, { Component } from 'react';
import debounce from 'lodash/debounce';

import css from './forms.css';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';

class Policy extends Component {
  constructor(props) {
    super(props);
    this.formAttributes = {
      policyId: 0,
      rate: '',
    };
    this.state = { policyId: '' };
  }

  handleSelectPolicy = (e, i, id) => {
    e.preventDefault();
    this.setState({ policyId: id });
    this.formAttributes.policyId = id;
  };

  handleInputChange = (e, value) => {
    // Update internal form attributes
    this.formAttributes.userName = value;

    // Update parent form attributes
    this.props.updateForm(this.formAttributes);
  };

  handleOnBlur = () => {
    if (this.formAttributes.rate.length < 1) return;
    this.props.addAnotherPolicy();
  }

  render() {
    return (
      <div className={css.root}>
        <section>
          <SelectField
            value={this.state.policyId}
            hintText="Select a policy type."
            onChange={this.handleSelectPolicy}
            style={{ margin: '0 10px' }}
          >
            {this.props.result.map(policyId =>
              <MenuItem
                key={this.props.policies.get(`${policyId}`).get('slug')}
                value={this.props.policies.get(`${policyId}`).get('id')}
                primaryText={this.props.policies.get(`${policyId}`).get('name')}
              />
            )}
          </SelectField>
          <TextField
            floatingLabelText="Policy Rate"
            onChange={debounce(this.handleInputChange, 500)}
            onBlur={this.handleOnBlur}
            className={css.textField}
            fullWidth={true}
          />
        </section>
      </div>
    );
  }
};

export default Policy;



/** WEBPACK FOOTER **
 ** ./components/forms/Policy.js
 **/